import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import fetchTodos from "../redux/todos/thunk/fetchTodos";
import CompleteTodo from "./CompleteTodo";

export default function CompleteTodoList() {
  const todos = useSelector((state) => state.todos);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchTodos);
  }, [dispatch]);

  const filterByStatus = (todo) => {
    return todo.completed;
  };

  return (
    <div className="mt-2 text-gray-700 text-sm max-h-[300px] overflow-y-auto">
      {todos.filter(filterByStatus).map((todo) => (
        <CompleteTodo todo={todo} key={todo.id} />
      ))}
      {todos.filter(filterByStatus).length === 0 && (
        <p className="text-red-300 text-center pt-2">No task</p>
      )}
    </div>
  );
}
